import { useMemo } from "react";
import { useSelector } from "react-redux";
import { isArray, find, get } from "lodash";
import useCurrentWorkOrder from "./useCurrentWorkOrder";

// Returns whether the current user's job contract is end-to-end enabled.
export const useIsEndToEndEnabled = (workOrderNumber) => {
    const contracts = useSelector((state) => state.contracts);
    const currentWorkOrder = useCurrentWorkOrder(workOrderNumber);

    const isEndToEndEnabled = useMemo(() => {
        const contractId = currentWorkOrder?.contractNumber?.contractNumber ?? currentWorkOrder?.contractNumber;
        if (!contractId || !isArray(contracts)) return false;
        const matchedContract = find(contracts, { contractNumber: contractId });
        return !!get(matchedContract, "isEndToEndEnabled");
    }, [contracts, currentWorkOrder]);

    return isEndToEndEnabled;
};

export default useIsEndToEndEnabled;
